module.exports = "/_next/static/images/DiagnosisOrder-6af71372e997218a81b54dd953b78b38.png";